import { faCheck } from '@fortawesome/pro-regular-svg-icons/faCheck';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Component } from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { FleetCustomer } from '../../../../../store/fleet-customers';
import { conditionalClassLister } from '../../../../../utils/class-helpers';
import ToggleDisplay from '../../../../../utils/toggle-display';
import styles from './fleet-customer-selection-item.module.scss';

class FleetCustomerSelectionItem extends Component<AllProps> {
    public render(): JSX.Element {
        const { fleetCustomer, selected, canSelect } = this.props;

        const itemClasses = conditionalClassLister(styles)({
            fcItem: true,
            isDisabled: !canSelect,
        });

        return (
            <div key={fleetCustomer.id} className={itemClasses} onClick={() => this.onSelect()}>
                <div className={styles.indicator}>
                    <ToggleDisplay if={selected}>
                        <FontAwesomeIcon icon={faCheck} />
                    </ToggleDisplay>
                </div>
                <div className={styles.name}>{fleetCustomer.name}</div>
            </div>
        );
    }

    private onSelect(): void {
        const { canSelect, onSelect } = this.props;

        if (canSelect && onSelect) {
            onSelect();
        }
    }
}

export default withTranslation()(FleetCustomerSelectionItem);

interface OwnProps {
    canSelect: boolean;
    fleetCustomer: FleetCustomer;
    onSelect?: () => void;
    selected: boolean;
}

type AllProps = OwnProps & WithTranslation;
